import PropTypes from "prop-types";
import { Card, Typography, Tooltip, Button } from "antd";
import coinImage from "../../../assets/icons/header-coin.svg";
import "./ProductCard.scss";
import { useTranslation } from "react-i18next";
import { memo, useCallback, useMemo } from "react";

const { Text, Title } = Typography;

// eslint-disable-next-line no-unused-vars
const ProductCard = ({ product, onAddToCart, handleSelectProduct }) => {
  const { t } = useTranslation("common");

  const formatDisplayName = useCallback((name, maxLength = 20) => {
    return name?.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
  }, []);

  // const handleCartClick = useCallback(
  //   (e) => {
  //     e.stopPropagation();
  //     onAddToCart(product);
  //   },
  //   [onAddToCart, product]
  // );

  const handleCardClick = useCallback(() => {
    handleSelectProduct(product);
  }, [handleSelectProduct, product]);

  // Memoized product data
  const productName = useMemo(() => product?.name, [product?.name]);
  const productImage = useMemo(
    () => product?.product_image,
    [product?.product_image]
  );
  const productPrice = useMemo(
    () => product?.prices[0]?.coins || 0,
    [product?.prices]
  );

    const productAmount = useMemo(
    () => product?.prices[0]?.sar || 0,
    [product?.prices]
  );
  const productCategory = useMemo(() => product?.category, [product?.category]);

  // Memoized formatted name
  const formattedName = useMemo(
    () => formatDisplayName(productName),
    [productName, formatDisplayName]
  );

  // Memoized card cover
  const cardCover = useMemo(
    () => (
      <div className="product-image">
        <img
          alt={productName}
          src={productImage}
          style={{ width: "100%", minHeight: "160px", objectFit: "cover", maxHeight: "160px" }}
        />
      </div>
    ),
    [productImage, productName]
  );

  // Memoized price section
  const priceSection = useMemo(
    () => (
      <>
        <Text strong className="product-price">
          <span>{t("store_header.price")} :</span>{" "}
          <img
            src={coinImage}
            alt="coin-image"
            style={{ height: "15px", width: "15px", marginRight: "5px" }}
          />
          {productPrice}
        </Text>

        <Text strong className="product-price">
          <span>{t("product.amount")} :</span>{" "}
          {/* <img
            src={coinImage}
            alt="coin-image"
            style={{ height: "15px", width: "15px", marginRight: "5px" }}
          /> */}
          {productAmount} <span>{product?.brand_accepted_currency}</span>
        </Text>
      </>
    ),
    [t, productPrice]
  );

  // Memoized category section
  const categorySection = useMemo(
    () => (
      <Text type="secondary" className="product-category">
        {productCategory}
      </Text>
    ),
    [productCategory]
  );

  // Memoized button section
  const buttonSection = useMemo(
    () => (
      <Button className="buy-now-btn" onClick={handleCardClick}>
        {t("product.buy_now")}
      </Button>
    ),
    [t, handleCardClick]
  );

  return (
    <Card
      hoverable
      className="product-card"
      style={{ background: "#141414", border: "1px solid #08ff96" }}
      onClick={handleCardClick}
      cover={cardCover}
    >
      <div className="product-content">
        <Title level={5} className="product-title">
          <Tooltip title={productName}>
            <p className="card-title">{formattedName}</p>
          </Tooltip>
        </Title>

        <div className="product-meta">
          {priceSection}
          {categorySection}
        </div>

        {buttonSection}
      </div>
    </Card>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    prices: PropTypes.arrayOf(
      PropTypes.shape({
        coins: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sar: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ).isRequired,
    category: PropTypes.string,
    rating: PropTypes.number,
    product_image: PropTypes.string,
    brand_accepted_currency: PropTypes.string,
  }).isRequired,
  onAddToCart: PropTypes.func.isRequired,
  handleSelectProduct: PropTypes.func.isRequired,
};

export default memo(ProductCard);
